//Call_[npm_run_updateIndexes]_to_update_this_file.

// @create-index

import _relation from './relation';
export const relation = _relation;
export default {relation};

